import Api from 'utils/ApiRequest'
import API_URL from 'constants/api'
import { actionSet } from './utils'
import { showSpinner, hideSpinner } from 'action/spinner'
import { getPages } from 'component/pagination/utils'

import {
  FETCH_HELP_CONFIGURATION_REQUEST,
  FETCH_HELP_CONFIGURATION_SUCCESS,
  FETCH_HELP_CONFIGURATION_ERROR,
  REMOVE_HELP_CONFIGURATION_REQUEST,
  REMOVE_HELP_CONFIGURATION_SUCCESS,
  REMOVE_HELP_CONFIGURATION_ERROR,
  UPDATE_HELP_CONFIGURATION_REQUEST,
  UPDATE_HELP_CONFIGURATION_SUCCESS,
  UPDATE_HELP_CONFIGURATION_ERROR,
} from 'actionTypes'

export const fetchHelpConfig = (token, filters, callback) => (dispatch) => {
  new Api(token, dispatch)
    .post(
      `${API_URL.FETCH_HELP_CONFIG}?page=${filters.page}&size=${filters.size}`,
      filters
    )
    .then(dispatch(showSpinner()))
    .then(dispatch(actionSet(FETCH_HELP_CONFIGURATION_REQUEST)))
    .then(
      (response) => {
        dispatch(getPages(response.data.pages))
        dispatch(
          actionSet(FETCH_HELP_CONFIGURATION_SUCCESS, response.data.resultList)
        )
        dispatch(hideSpinner())
      },
      (error) => dispatch(actionSet(FETCH_HELP_CONFIGURATION_ERROR, error))
    )
    .finally(() => {
      callback()
      dispatch(hideSpinner())
    })
}

export const saveHelpConfig = (token, data, onSuccess) => (dispatch) => {
  new Api(token, dispatch)
    .post(`${API_URL.SAVE_HELP_CONFIG}`, data)
    .then(dispatch(showSpinner()))
    .then(dispatch(actionSet(UPDATE_HELP_CONFIGURATION_REQUEST)))
    .then(
      (response) => {
        dispatch(actionSet(UPDATE_HELP_CONFIGURATION_SUCCESS, response.data))
        onSuccess && onSuccess(response.data, 'save')
      },
      (error) => dispatch(actionSet(UPDATE_HELP_CONFIGURATION_ERROR, error))
    )
    .finally(() => dispatch(hideSpinner()))
}

export const removeHelpConfig = (token, data, onSuccess) => (dispatch) => {
  new Api(token, dispatch)
    .post(`${API_URL.REMOVE_HELP_CONFIG}`, data)
    .then(dispatch(showSpinner()))
    .then(dispatch(actionSet(REMOVE_HELP_CONFIGURATION_REQUEST)))
    .then(
      (response) => {
        dispatch(actionSet(REMOVE_HELP_CONFIGURATION_SUCCESS, response.data))
        onSuccess && onSuccess(response.data, 'remove')
      },
      (error) => dispatch(actionSet(REMOVE_HELP_CONFIGURATION_ERROR, error))
    )
    .finally(() => dispatch(hideSpinner()))
}
